import React from 'react';
import PropTypes from 'prop-types';

import './Burger.css';

const Burger = ({ active, clickHandler }) => {
    return (
        <div
            className={`burger ${active && 'active'}`}
            onClick={clickHandler}
        >
            <span className="bar bar__top"></span>
            <span className="bar bar__middle"></span>
            <span className="bar bar__bottom"></span>
        </div>
    );
};

Burger.propTypes = {
    active: PropTypes.bool.isRequired,
    clickHandler: PropTypes.func.isRequired
};

export default Burger;


// WEBPACK FOOTER //
// ./src/components/navigation/Burger/Burger.jsx